import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { FULL_PERCENT } from '../../constants';

import { Container, Background, Progress } from './styles';

const ProgressBar = (props) => {
  const {
    pagesList,
    page,
  } = props;

  const [percent, setPercent] = useState(0);

  const lastSurveyPage = _.last(pagesList);

  const handleProgressPercent = useCallback(async () => {
    if (!_.isEmpty(page) || !_.isEmpty(pagesList)) {
      const getPercent = FULL_PERCENT / pagesList.length;

      const surveyPagePosition = _.findIndex(pagesList, (surveyPage) => (
        surveyPage.id === page.id
      ));

      if (surveyPagePosition === 1) {
        return setPercent(getPercent);
      }

      if (surveyPagePosition > 1 && surveyPagePosition <= pagesList.length) {
        return setPercent(surveyPagePosition * getPercent);
      }

      if (page.id === lastSurveyPage.id) {
        return setPercent(FULL_PERCENT);
      }
    }

    return percent;
  }, [pagesList, page, lastSurveyPage]);

  useEffect(() => {
    handleProgressPercent();
  }, [handleProgressPercent]);

  return (
    <Container>
      <Background />
      <Progress percent={percent} />
    </Container>
  );
};

ProgressBar.propTypes = {
  pagesList: PropTypes.arrayOf(PropTypes.object),
  page: PropTypes.shape({
    id: PropTypes.string,
  }),
};

ProgressBar.defaultProps = {
  pagesList: [],
  page: {},
};

export default ProgressBar;
